import Clarity from '@microsoft/clarity';

/**
 * Microsoft Clarity loader
 *
 * Initialises Clarity session recording via the official npm package.
 * Called by `CookieConsentContext` only after the visitor accepts cookies,
 * ensuring Clarity never loads without consent.
 *
 * The function is idempotent — if `window.clarity` already exists (meaning
 * the SDK has been initialised), the call is a no-op.
 *
 */
const CLARITY_PROJECT_ID = process.env.NEXT_PUBLIC_CLARITY_ID;

// Extend the Window type so TypeScript knows Clarity attaches itself globally
declare global {
  interface Window {
    clarity?: unknown;
  }
}

export function loadClarity() {
  if (typeof window === 'undefined') return;

  // Guard against double-initialisation
  if (window?.clarity) {
    return;
  }

  Clarity.init(CLARITY_PROJECT_ID ?? '');
}
